import LazyLoad from "vanilla-lazyload";

export function initLazyLoad() {
  // attach to the window object so React components can call
  // window.lazyload.update() when needed
  window.lazyload = new LazyLoad({});
}
